import React from "react";
import { IconT } from "types/utils";

const ApprovedCheckIcon = ({ height = 24, width = 24 }: IconT) => (
  <svg width={width} height={height} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_d_2081_7623)">
      <rect x="1" y="0.5" width="16" height="16" rx="8" fill="url(#paint0_linear_2081_7623)" />
      <rect
        x="1.375"
        y="0.875"
        width="15.25"
        height="15.25"
        rx="7.625"
        stroke="url(#paint1_linear_2081_7623)"
        strokeWidth="0.75"
      />
    </g>
    <path
      d="M12.5313 4.56184C12.126 4.22828 11.5362 4.29716 11.2136 4.71533L7.55386 10.4039L5.95641 8.75435C5.62773 8.41393 5.11176 8.39678 4.80383 8.71434C4.49646 9.0316 4.51333 9.56467 4.84229 9.90481L7.25119 12.3941C7.53284 12.6845 7.9434 12.7236 8.25161 12.5347C8.38441 12.4735 8.50614 12.3841 8.60325 12.2586L12.6793 5.92238C13.0025 5.5045 12.9352 4.89568 12.5313 4.56184Z"
      fill="white"
    />
    <defs>
      <filter
        id="filter0_d_2081_7623"
        x="0"
        y="0"
        width="18"
        height="18"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="0.5" />
        <feGaussianBlur stdDeviation="0.5" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2081_7623" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2081_7623" result="shape" />
      </filter>
      <linearGradient
        id="paint0_linear_2081_7623"
        x1="3.80702"
        y1="-6.16667"
        x2="17.933"
        y2="-4.75566"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#20C2F1" />
        <stop offset="1" stopColor="#0070F4" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_2081_7623"
        x1="3.80702"
        y1="-6.16667"
        x2="17.933"
        y2="-4.75566"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#20C2F1" />
        <stop offset="1" stopColor="#0070F4" />
      </linearGradient>
    </defs>
  </svg>
);

export default ApprovedCheckIcon;
